module.exports = __webpack_public_path__ + "img/iberostar-lisboa.d5291c93.jpg";